export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
  isNew: boolean;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  status: '连载中' | '已完结';
  views: number;
  tags: string[];
  chapters: ComicChapter[];
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories: { name: string; slug: string; icon: string; description: string }[] = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，心动瞬间不容错过' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '充满想象力的奇幻世界，带你进入魔法冒险' },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line', description: '热血激燃的战斗场面，肾上腺素飙升' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑日常，笑到停不下来' },
  { name: '校园', slug: 'school', icon: 'ri-building-line', description: '青春的校园时光，满满的回忆与感动' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑剧情，真相层层揭开' },
  { name: 'BL', slug: 'bl', icon: 'ri-user-heart-line', description: '感人至深的BL故事，触动心底的温柔' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', description: '深刻动人的剧情漫画，每页都是艺术' },
];

export const banners: { title: string; subtitle: string; image: string; link: string; tag: string }[] = [
  {
    title: '蜜桃少年',
    subtitle: '热门BL漫画，甜蜜又虐心的青春物语，千万读者感动推荐',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20illustration%20of%20two%20young%20men%20in%20a%20romantic%20cherry%20blossom%20scene%2C%20soft%20pink%20and%20warm%20peach%20tones%2C%20gentle%20sunlight%2C%20dreamy%20atmosphere%2C%20Korean%20manhwa%20art%20style%2C%20emotional%20and%20tender%20mood%2C%20clean%20composition%20with%20shallow%20depth%20of%20field&width=1600&height=700&seq=manga-banner-01&orientation=landscape',
    link: '/article/peach-boy',
    tag: '热门推荐',
  },
  {
    title: '秘密花园',
    subtitle: '奇幻恋爱漫画，花丛中的秘密邂逅，唯美画风引爆少女心',
    image: 'https://readdy.ai/api/search-image?query=Magical%20fantasy%20garden%20scene%20in%20anime%20manhwa%20style%2C%20glowing%20flowers%20and%20fireflies%2C%20a%20couple%20standing%20among%20blooming%20roses%2C%20soft%20ethereal%20lighting%2C%20warm%20golden%20and%20emerald%20tones%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20dreamy%20composition&width=1600&height=700&seq=manga-banner-02&orientation=landscape',
    link: '/article/secret-garden',
    tag: '新作上线',
  },
  {
    title: '剑与魔法',
    subtitle: '热血奇幻冒险，少年剑士的成长之路，史诗级战斗场面',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20scene%20with%20a%20young%20swordsman%20holding%20a%20glowing%20magical%20sword%2C%20dramatic%20lighting%20with%20sparks%20and%20magic%20effects%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20Korean%20manhwa%20art%20style%2C%20cinematic%20composition&width=1600&height=700&seq=manga-banner-03&orientation=landscape',
    link: '/article/sword-magic',
    tag: '榜单第一',
  },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'peach-boy',
    title: '蜜桃少年',
    author: '金作家',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%2C%20two%20handsome%20young%20men%20with%20soft%20features%2C%20peach%20blossom%20background%2C%20warm%20pink%20and%20peach%20color%20tones%2C%20romantic%20BL%20manga%20aesthetic%2C%20delicate%20line%20art%2C%20clean%20composition%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'BL',
    categorySlug: 'bl',
    rating: 4.9,
    description: '在樱花纷飞的季节，两个少年的命运悄然交织。蜜桃般的甜蜜初恋，夹杂着青春的苦涩与成长。这是一部关于勇气、爱与自我认同的动人故事。金作家以其细腻的笔触和深刻的情感刻画，为读者呈现了一个既甜蜜又虐心的BL经典之作。每一页都充满了令人心动的瞬间，每一个角色都鲜活而真实。',
    status: '连载中',
    views: 1280000,
    tags: ['BL', '校园', '初恋', '治愈'],
    chapters: [
      { id: 'ch-1-1', title: '第1话 樱花下的相遇', chapterNumber: 1, updateDate: '2026-07-20', isNew: false },
      { id: 'ch-1-2', title: '第2话 图书馆的秘密', chapterNumber: 2, updateDate: '2026-07-22', isNew: false },
      { id: 'ch-1-3', title: '第3话 心跳的距离', chapterNumber: 3, updateDate: '2026-07-25', isNew: false },
      { id: 'ch-1-4', title: '第4话 雨天的约定', chapterNumber: 4, updateDate: '2026-07-28', isNew: false },
      { id: 'ch-1-5', title: '第5话 星光下的告白', chapterNumber: 5, updateDate: '2026-08-01', isNew: true },
      { id: 'ch-1-6', title: '第6话 无法言说的心事', chapterNumber: 6, updateDate: '2026-08-04', isNew: true },
    ],
    updateDate: '2026-08-04',
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    slug: 'secret-garden',
    title: '秘密花园',
    author: '李漫画家',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20manhwa%20cover%20illustration%2C%20a%20beautiful%20girl%20in%20a%20magical%20garden%20with%20glowing%20flowers%2C%20soft%20pastel%20colors%2C%20ethereal%20fairy%20tale%20aesthetic%2C%20Korean%20webtoon%20style%2C%20dreamy%20atmosphere%2C%20delicate%20artwork&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 4.8,
    description: '一个偶然的机会，少女小樱发现了一座隐藏在都市中的神秘花园。花园里盛开着世间罕见的奇花异草，还有一位神秘的守园少年。随着探索的深入，小樱发现自己与这座花园之间，有着超越时空的奇妙联系。',
    status: '连载中',
    views: 960000,
    tags: ['奇幻', '恋爱', '魔法', '都市'],
    chapters: [
      { id: 'ch-2-1', title: '第1话 神秘的门扉', chapterNumber: 1, updateDate: '2026-07-15', isNew: false },
      { id: 'ch-2-2', title: '第2话 花园的主人', chapterNumber: 2, updateDate: '2026-07-18', isNew: false },
      { id: 'ch-2-3', title: '第3话 月光下的魔法', chapterNumber: 3, updateDate: '2026-07-22', isNew: false },
      { id: 'ch-2-4', title: '第4话 被封印的记忆', chapterNumber: 4, updateDate: '2026-07-28', isNew: false },
      { id: 'ch-2-5', title: '第5话 命运的齿轮', chapterNumber: 5, updateDate: '2026-08-02', isNew: true },
    ],
    updateDate: '2026-08-02',
    isHot: true,
    isNew: true,
  },
  {
    id: '3',
    slug: 'sword-magic',
    title: '剑与魔法',
    author: '崔画师',
    coverImage: 'https://readdy.ai/api/search-image?query=Action%20fantasy%20manhwa%20cover%2C%20a%20young%20warrior%20with%20a%20glowing%20sword%2C%20epic%20magical%20battle%20background%2C%20dramatic%20orange%20and%20gold%20lighting%2C%20Korean%20webtoon%20action%20style%2C%20dynamic%20composition%2C%20intense%20atmosphere&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    rating: 4.7,
    description: '在剑与魔法交织的世界里，少年艾伦踏上了成为最强剑士的征程。从被嘲笑的吊车尾，到独当一面的英雄，他用汗水与热血书写了属于自己的传奇。崔画师以其震撼的战斗画面和紧凑的剧情节奏，创造了一部让人欲罢不能的热血漫画。',
    status: '连载中',
    views: 1560000,
    tags: ['动作', '奇幻', '冒险', '热血'],
    chapters: [
      { id: 'ch-3-1', title: '第1话 起点', chapterNumber: 1, updateDate: '2026-06-10', isNew: false },
      { id: 'ch-3-2', title: '第2话 觉醒', chapterNumber: 2, updateDate: '2026-06-15', isNew: false },
      { id: 'ch-3-3', title: '第3话 试炼', chapterNumber: 3, updateDate: '2026-06-20', isNew: false },
      { id: 'ch-3-4', title: '第4话 初战', chapterNumber: 4, updateDate: '2026-06-28', isNew: false },
      { id: 'ch-3-5', title: '第5话 伙伴', chapterNumber: 5, updateDate: '2026-07-05', isNew: false },
      { id: 'ch-3-6', title: '第6话 强敌', chapterNumber: 6, updateDate: '2026-07-15', isNew: false },
      { id: 'ch-3-7', title: '第7话 突破', chapterNumber: 7, updateDate: '2026-07-25', isNew: false },
      { id: 'ch-3-8', title: '第8话 决战前夜', chapterNumber: 8, updateDate: '2026-08-01', isNew: true },
    ],
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    slug: 'daily-laugh',
    title: '每日一笑',
    author: '赵逗趣',
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20manhwa%20cover%2C%20chibi%20style%20characters%20with%20exaggerated%20expressions%2C%20bright%20and%20colorful%20background%2C%20playful%20Korean%20webtoon%20style%2C%20humorous%20slice%20of%20life%20aesthetic%2C%20cheerful%20atmosphere&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    rating: 4.6,
    description: '生活中的每一个小瞬间都可以变成爆笑段子！赵逗趣以独特的幽默视角，将日常琐事变成了一幕幕让人捧腹大笑的漫画。从办公室趣事到家庭欢乐，每一话都能让你忘却烦恼，开怀大笑。',
    status: '已完结',
    views: 890000,
    tags: ['搞笑', '日常', '轻松', '四格'],
    chapters: [
      { id: 'ch-4-1', title: '第1话 上班第一天', chapterNumber: 1, updateDate: '2026-05-01', isNew: false },
      { id: 'ch-4-2', title: '第2话 午餐大作战', chapterNumber: 2, updateDate: '2026-05-05', isNew: false },
      { id: 'ch-4-3', title: '第3话 电梯惊魂', chapterNumber: 3, updateDate: '2026-05-10', isNew: false },
      { id: 'ch-4-4', title: '第4话 加班夜', chapterNumber: 4, updateDate: '2026-05-15', isNew: false },
    ],
    updateDate: '2026-05-15',
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    slug: 'campus-days',
    title: '校园时光',
    author: '吴青春',
    coverImage: 'https://readdy.ai/api/search-image?query=School%20life%20romance%20manhwa%20cover%2C%20high%20school%20students%20in%20uniform%20under%20cherry%20blossoms%2C%20warm%20spring%20lighting%2C%20youthful%20and%20nostalgic%20Korean%20webtoon%20style%2C%20gentle%20pastel%20colors%2C%20clean%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '校园',
    categorySlug: 'school',
    rating: 4.5,
    description: '高中三年，是每个人心中最柔软的回忆。吴青春用温暖的画风，描绘了主角小宇和他的朋友们在校园里经历的点点滴滴——友情、暗恋、考试、社团活动……每一个场景都仿佛在讲述我们自己的故事。',
    status: '连载中',
    views: 720000,
    tags: ['校园', '青春', '友情', '恋爱'],
    chapters: [
      { id: 'ch-5-1', title: '第1话 开学第一天', chapterNumber: 1, updateDate: '2026-07-01', isNew: false },
      { id: 'ch-5-2', title: '第2话 同桌的你', chapterNumber: 2, updateDate: '2026-07-05', isNew: false },
      { id: 'ch-5-3', title: '第3话 社团招新', chapterNumber: 3, updateDate: '2026-07-10', isNew: false },
      { id: 'ch-5-4', title: '第4话 运动会', chapterNumber: 4, updateDate: '2026-07-18', isNew: false },
      { id: 'ch-5-5', title: '第5话 文化祭', chapterNumber: 5, updateDate: '2026-07-28', isNew: true },
    ],
    updateDate: '2026-07-28',
    isHot: false,
    isNew: true,
  },
  {
    id: '6',
    slug: 'truth-seeker',
    title: '真相追踪',
    author: '郑推理',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manhwa%20cover%2C%20dark%20alley%20with%20a%20detective%20silhouette%2C%20moody%20noir%20atmosphere%2C%20dramatic%20shadows%20and%20muted%20colors%2C%20Korean%20webtoon%20mystery%20style%2C%20suspenseful%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 4.8,
    description: '一座平静的小城，接连发生离奇案件。前刑警韩真以私家侦探的身份，深入调查每一个被掩盖的真相。郑推理以其严谨的逻辑和出人意料的剧情反转，让读者在每一话结尾都忍不住惊呼。这是一部让人欲罢不能的悬疑推理力作。',
    status: '连载中',
    views: 1100000,
    tags: ['悬疑', '推理', '犯罪', '都市'],
    chapters: [
      { id: 'ch-6-1', title: '第1话 失踪者', chapterNumber: 1, updateDate: '2026-06-01', isNew: false },
      { id: 'ch-6-2', title: '第2话 不在场证明', chapterNumber: 2, updateDate: '2026-06-08', isNew: false },
      { id: 'ch-6-3', title: '第3话 第二个受害者', chapterNumber: 3, updateDate: '2026-06-15', isNew: false },
      { id: 'ch-6-4', title: '第4话 隐藏的线索', chapterNumber: 4, updateDate: '2026-06-25', isNew: false },
      { id: 'ch-6-5', title: '第5话 突破口', chapterNumber: 5, updateDate: '2026-07-05', isNew: false },
      { id: 'ch-6-6', title: '第6话 真相逼近', chapterNumber: 6, updateDate: '2026-07-20', isNew: false },
      { id: 'ch-6-7', title: '第7话 最终对决', chapterNumber: 7, updateDate: '2026-08-03', isNew: true },
    ],
    updateDate: '2026-08-03',
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    slug: 'blue-romance',
    title: '蓝色恋歌',
    author: '韩浪漫',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20BL%20manhwa%20cover%2C%20two%20men%20by%20the%20ocean%20at%20sunset%2C%20soft%20blue%20and%20golden%20tones%2C%20tender%20atmosphere%2C%20Korean%20webtoon%20romance%20style%2C%20emotional%20expression%2C%20beautiful%20seascape&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'BL',
    categorySlug: 'bl',
    rating: 4.7,
    description: '音乐学院的钢琴天才与街头吉他少年，两个截然不同的灵魂因音乐而相遇。韩浪漫用如诗般的画面和动人的旋律感，讲述了一段跨越阶层与偏见的纯爱故事。每一个音符都是心动的告白，每一页都是视觉的享受。',
    status: '连载中',
    views: 670000,
    tags: ['BL', '音乐', '都市', '治愈'],
    chapters: [
      { id: 'ch-7-1', title: '第1话 街角的旋律', chapterNumber: 1, updateDate: '2026-07-10', isNew: false },
      { id: 'ch-7-2', title: '第2话 琴键上的邂逅', chapterNumber: 2, updateDate: '2026-07-15', isNew: false },
      { id: 'ch-7-3', title: '第3话 合奏', chapterNumber: 3, updateDate: '2026-07-22', isNew: false },
      { id: 'ch-7-4', title: '第4话 不和谐音', chapterNumber: 4, updateDate: '2026-07-30', isNew: true },
    ],
    updateDate: '2026-07-30',
    isHot: false,
    isNew: false,
  },
  {
    id: '8',
    slug: 'tears-of-angel',
    title: '天使之泪',
    author: '陈剧作',
    coverImage: 'https://readdy.ai/api/search-image?query=Emotional%20drama%20manhwa%20cover%2C%20a%20girl%20with%20tears%20and%20angel%20wings%2C%20soft%20ethereal%20lighting%2C%20melancholic%20atmosphere%2C%20beautiful%20Korean%20webtoon%20art%20style%2C%20touching%20story%20aesthetic%2C%20white%20and%20gold%20tones&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    rating: 4.9,
    description: '她是被命运捉弄的天使，落入凡间只为完成一个任务——收集一千滴真心的眼泪。在这趟旅程中，她见证了人间的悲欢离合，也渐渐理解了什么是真正的爱与牺牲。陈剧作以深邃的故事和精美的画面，打造了一部令人动容的剧情漫画。',
    status: '已完结',
    views: 2100000,
    tags: ['剧情', '奇幻', '治愈', '催泪'],
    chapters: [
      { id: 'ch-8-1', title: '第1话 坠落人间', chapterNumber: 1, updateDate: '2026-03-01', isNew: false },
      { id: 'ch-8-2', title: '第2话 第一滴泪', chapterNumber: 2, updateDate: '2026-03-08', isNew: false },
      { id: 'ch-8-3', title: '第3话 医院的天使', chapterNumber: 3, updateDate: '2026-03-15', isNew: false },
      { id: 'ch-8-4', title: '第4话 离别的眼泪', chapterNumber: 4, updateDate: '2026-03-22', isNew: false },
      { id: 'ch-8-5', title: '第5话 重逢', chapterNumber: 5, updateDate: '2026-04-01', isNew: false },
      { id: 'ch-8-6', title: '第6话 最后的任务', chapterNumber: 6, updateDate: '2026-04-10', isNew: false },
      { id: 'ch-8-7', title: '最终话 回归', chapterNumber: 7, updateDate: '2026-04-20', isNew: false },
    ],
    updateDate: '2026-04-20',
    isHot: true,
    isNew: false,
  },
  {
    id: '9',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '林奇幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20magic%20academy%20manhwa%20cover%2C%20students%20in%20magical%20robes%20at%20a%20grand%20castle%20school%2C%20magical%20sparks%20and%20spell%20effects%2C%20warm%20golden%20light%2C%20Korean%20webtoon%20fantasy%20style%2C%20majestic%20atmosphere&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 4.6,
    description: '在隐藏于云层之上的魔法学院里，一群天赋异禀的少年少女正在学习掌控元素的力量。然而，古老的预言预示着一场席卷魔法世界的危机即将到来。林奇幻构建了一个宏大而细致的魔法世界，让读者沉浸其中。',
    status: '连载中',
    views: 850000,
    tags: ['奇幻', '学院', '魔法', '冒险'],
    chapters: [
      { id: 'ch-9-1', title: '第1话 入学通知', chapterNumber: 1, updateDate: '2026-06-20', isNew: false },
      { id: 'ch-9-2', title: '第2话 分班仪式', chapterNumber: 2, updateDate: '2026-06-28', isNew: false },
      { id: 'ch-9-3', title: '第3话 第一堂魔法课', chapterNumber: 3, updateDate: '2026-07-05', isNew: false },
      { id: 'ch-9-4', title: '第4话 禁林探险', chapterNumber: 4, updateDate: '2026-07-15', isNew: false },
      { id: 'ch-9-5', title: '第5话 预言石碑', chapterNumber: 5, updateDate: '2026-07-25', isNew: false },
      { id: 'ch-9-6', title: '第6话 暗流涌动', chapterNumber: 6, updateDate: '2026-08-02', isNew: true },
    ],
    updateDate: '2026-08-02',
    isHot: false,
    isNew: true,
  },
  {
    id: '10',
    slug: 'martial-legend',
    title: '武林传奇',
    author: '张武侠',
    coverImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20action%20manhwa%20cover%2C%20a%20warrior%20in%20traditional%20martial%20arts%20pose%20on%20a%20mountain%20peak%2C%20dramatic%20wind%20and%20clouds%2C%20epic%20atmosphere%2C%20Korean%20webtoon%20action%20style%2C%20strong%20dynamic%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    rating: 4.5,
    description: '江湖风云再起，少年侠客踏上了寻找失传武功秘籍的旅程。张武侠以其精湛的动作设计和深厚的武侠文化底蕴，为读者呈现了一个快意恩仇的武林世界。拳拳到肉的打斗场面，侠骨柔情的人物刻画，让人热血沸腾。',
    status: '连载中',
    views: 580000,
    tags: ['动作', '武侠', '冒险', '古风'],
    chapters: [
      { id: 'ch-10-1', title: '第1话 山村少年', chapterNumber: 1, updateDate: '2026-07-01', isNew: false },
      { id: 'ch-10-2', title: '第2话 奇遇', chapterNumber: 2, updateDate: '2026-07-08', isNew: false },
      { id: 'ch-10-3', title: '第3话 初入江湖', chapterNumber: 3, updateDate: '2026-07-18', isNew: false },
      { id: 'ch-10-4', title: '第4话 擂台赛', chapterNumber: 4, updateDate: '2026-07-28', isNew: true },
    ],
    updateDate: '2026-07-28',
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    slug: 'love-formula',
    title: '恋爱方程式',
    author: '孙理科',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20school%20romance%20manhwa%20cover%2C%20a%20couple%20of%20high%20school%20students%20blushing%20in%20a%20classroom%2C%20soft%20pink%20and%20warm%20lighting%2C%20Korean%20webtoon%20romance%20style%2C%20sweet%20and%20innocent%20atmosphere&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    rating: 4.4,
    description: '理工科学霸遇到了文科班才女，两个完全不同世界的人，因为一次偶然的课题合作走到了一起。孙理科用独特的理科生视角，将恋爱中的每一个小心思都用"公式"来解读，既有理性又有浪漫，让人会心一笑。',
    status: '已完结',
    views: 450000,
    tags: ['恋爱', '校园', '喜剧', '治愈'],
    chapters: [
      { id: 'ch-11-1', title: '第1话 X+Y=？', chapterNumber: 1, updateDate: '2026-02-10', isNew: false },
      { id: 'ch-11-2', title: '第2话 概率问题', chapterNumber: 2, updateDate: '2026-02-18', isNew: false },
      { id: 'ch-11-3', title: '第3话 化学反应', chapterNumber: 3, updateDate: '2026-02-25', isNew: false },
      { id: 'ch-11-4', title: '第4话 最优解', chapterNumber: 4, updateDate: '2026-03-05', isNew: false },
      { id: 'ch-11-5', title: '最终话 证明完毕', chapterNumber: 5, updateDate: '2026-03-15', isNew: false },
    ],
    updateDate: '2026-03-15',
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    slug: 'night-detective',
    title: '深夜侦探',
    author: '马悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Noir%20mystery%20manhwa%20cover%2C%20a%20detective%20in%20trench%20coat%20under%20street%20lamp%20at%20night%2C%20dark%20rainy%20urban%20scene%2C%20moody%20atmosphere%2C%20Korean%20webtoon%20thriller%20style%2C%20dramatic%20shadows&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 4.6,
    description: '每当午夜钟声敲响，私家侦探林深便开始了他的一天。他专门接手警方不愿触碰的离奇案件。马悬疑以其独特的暗黑风格和多线叙事，将一个个看似无关的案件编织成了一张巨大的阴谋之网。',
    status: '连载中',
    views: 630000,
    tags: ['悬疑', '侦探', '都市', '暗黑'],
    chapters: [
      { id: 'ch-12-1', title: '第1话 午夜来电', chapterNumber: 1, updateDate: '2026-07-05', isNew: false },
      { id: 'ch-12-2', title: '第2话 废弃工厂', chapterNumber: 2, updateDate: '2026-07-12', isNew: false },
      { id: 'ch-12-3', title: '第3话 目击者', chapterNumber: 3, updateDate: '2026-07-20', isNew: false },
      { id: 'ch-12-4', title: '第4话 新的线索', chapterNumber: 4, updateDate: '2026-07-30', isNew: true },
    ],
    updateDate: '2026-07-30',
    isHot: false,
    isNew: true,
  },
];